export enum CloseStatus {
    OPEN = "open",
    DONE = "done",
    CANCELLED = "cancelled",
}

export const closeStatusLabels: Record<CloseStatus, string> = {
    [CloseStatus.OPEN]: "Open",
    [CloseStatus.DONE]: "Done",
    [CloseStatus.CANCELLED]: "Canceled",
};
